import { parseNumberByPrecision } from './parseNumberByPrecision';

export const handleBetAmountLimits = (maxBet, minBet, betAmount, setBetAmount, precision) => {
  if (maxBet < +betAmount) {
    setBetAmount(maxBet);
    return null;
  }
  if (minBet > +betAmount) {
    return setBetAmount(minBet);
  }

  return setBetAmount(parseNumberByPrecision(1, +betAmount, precision));
};
